<div class="card facilityCard p-3 mt-1" [class.bg-info-30]="facility.id == primaryFacilityId" [attr.data-testid]="'facility-card-' + facility.id">
	<div *ngIf="pastDue.enabled() && facility.past_due_count > 0" class="alert alert-danger mb-3 py-2 px-3 text-center font-weight-bold"
		data-testid="facility-card-past-due">
		{{ facility.past_due_count }} past due &middot; {{ facility.past_due_amount | currency }}
	</div>
	<div class="row mr-0 ml-0 align-items-center">
		<!-- Column 1: Name and IDs -->
		<div class="col-sm-12 col-lg-5 px-0 mb-3 selectable-text" (mousedown)="$event.stopPropagation()">
			<h5 class="card-title mb-1">{{ facility.name }}</h5>
			<h6 class="card-subtitle mb-2 text-muted" style="font-size: 12px">
				{{ facility.company_name }}
				<span class="ms-2">
					{{ facility.id == primaryFacilityId ? '(Primary)' : '' }}
				</span>
			</h6>
			<div class="mt-2" style="font-size: 13px;">
				<div><b>Account ID:</b> {{facility.company_id }}-{{ facility.id }}</div>
				<div *ngIf="facility.vendor_number && facility.dwolla_customer_id">
					<b>Caretria Account ID:</b> {{facility.dwolla_customer_id}}-{{ facility.vendor_number }}
				</div>
				<div *ngIf="facility.dea_number && featureFlagsService.getByEnv('ui','DEA')">
					<b>DEA:</b> {{ facility.dea_number }}
				</div>
				<div *ngIf="facility.state_license_number">
					<b>State License:</b> {{ facility.state_license_number }}
				</div>
				<div>
					<b>Payment Type:</b>
					<span *ngIf="paymentTypeLabel; else missingData"> {{ paymentTypeLabel }}</span>
				</div>
				<div>
					<b>Phone:</b>
					<span *ngIf="facility.phone; else missingData"> {{ facility.phone }}</span>
				</div>
				<div>
					<b>Email:</b>
					<span *ngIf="facility.email; else missingData"> {{ facility.email }}</span>
				</div>
				<ng-template #missingData><span class="text-muted font-italic"> missing</span></ng-template>
			</div>
		</div>
		<!-- Column 2: Address -->
		<div class="col-sm-12 col-lg-3 px-0 mb-3 selectable-text" (mousedown)="$event.stopPropagation()">
			<div class="text-muted mb-1" style="font-size: 12px;"><b>Shipping To:</b></div>
			<div style="font-size: 13px;">
				{{ facility.address_line_1 | titlecase }}<br />
				<div *ngIf="facility.address_line_2">
					{{ facility.address_line_2 | titlecase }}
				</div>
				<div *ngIf="facility.address_line_3">
					{{ facility.address_line_3 | titlecase }}
				</div>
				{{ facility.address_city | titlecase }},
				{{ facility.address_state }},
				{{ facility.address_postal_code }}
			</div>
		</div>
		<!-- Column 3: Warnings and Users -->
		<div class="col-sm-12 px-0 mb-3 text-right d-flex flex-wrap" [class.col-lg-4]="isReadOnly" [class.col-lg-2]="!isReadOnly">
			<div *ngIf="!facility.vetted" class="mr-2">
				<div id="vetting-alert-{{ facility.id }}" class="alert-icon vetting-icon">
					<i class="dx-icon-warning"></i>
				</div>
				<app-ms-tooltip [target]="'vetting-alert-' + facility.id" width="300"
					[tooltipText]="unvettedTooltipText"></app-ms-tooltip>
			</div>
			<div *ngIf="facility.user_count === 0" class="mr-2">
				<div id="user-count-alert-{{ facility.id }}" class="alert-icon user-count-icon"
					[style.cursor]="termsToolsEnabled ? 'pointer' : null"
					(click)="termsToolsEnabled && (showUsersPopup = true)"
					data-testid="facility-card-btn-open-add-user">
					<i class="dx-icon-user"></i>
				</div>
				<app-ms-tooltip [target]="'user-count-alert-' + facility.id" width="300"
					[tooltipText]="zeroUsersTooltip"></app-ms-tooltip>
			</div>
			<div *ngIf="showLicenseAlert" class="mr-2">
				<div id="license-alert-{{ facility.id }}" class="alert-icon" [ngClass]="licenseAlertClass">
					<i class="dx-icon-event"></i>
				</div>
				<app-ms-tooltip [target]="'license-alert-' + facility.id" width="300"
					[tooltipText]="licenseAlertTooltipText"></app-ms-tooltip>
			</div>
			<div *ngIf="facility.require_terms_agreement" class="mr-2">
				<div id="require-terms-{{ facility.id }}" class="alert-icon"
				[ngClass]="hardGateActive ? 'terms-blocked-icon' : 'expired-icon'"
					[style.cursor]="termsToolsEnabled ? 'pointer' : null"
					(click)="termsToolsEnabled && (showUsersPopup = true)"
					data-testid="facility-card-btn-terms-users">
					<i class="dx-icon-file"></i>
				</div>
				<app-ms-tooltip [target]="'require-terms-' + facility.id" width="300"
					[tooltipText]="termsPendingTooltip"></app-ms-tooltip>
			</div>
			<div *ngIf="facility.has_price_rules" class="mr-2">
				<div id="price-rules-alert-{{ facility.id }}" class="alert-icon price-rules-icon">
					<i class="dx-icon-money"></i>
				</div>
				<app-ms-tooltip [target]="'price-rules-alert-' + facility.id" width="250"
					tooltipText="This facility has a custom price."></app-ms-tooltip>
			</div>
			<div *ngIf="facility.users && facility.users?.length > 0" class="mr-2">
				<div id="users-alert-{{ facility.id }}" class="alert-icon users-icon" (click)="showUsersPopup = true" style="cursor: pointer;">
					<i class="dx-icon-users"></i>
				</div>
				<app-ms-tooltip [target]="'users-alert-' + facility.id" width="200" tooltipText="Click to view users"></app-ms-tooltip>
			</div>
		</div>
		<!-- Column 4: Action Button -->
		<div *ngIf="!isReadOnly" class="col-sm-12 col-lg-2 px-0 text-right">
			<div *ngIf="facility.id != primaryFacilityId && facility.vetted">
				<dx-button type="default" stylingMode="outlined" text="Select Facility"
					(onClick)="onSwitch()"
					[elementAttr]="{ 'data-testid': 'facility-card-btn-select' }"></dx-button>
			</div>
		</div>
	</div>
	<div *ngIf="showActionHint" class="action-hint small font-italic text-right mt-2"
		[class.action-hint-blocked]="hardGateActive"
		data-testid="facility-card-action-hint">
		<ng-container *ngIf="facility.user_count === 0; else sendTermsHint">
			No users on this account —
			<a (click)="openAddUser()" data-testid="facility-card-link-add-user">add a user</a>,
			then send them the terms link.
		</ng-container>
		<ng-template #sendTermsHint>
			{{ hardGateActive
				? 'Customer cannot place orders until the Terms & Conditions are accepted —'
				: "Customer hasn't accepted the Terms & Conditions —" }}
			<a (click)="showUsersPopup = true" data-testid="facility-card-link-send-terms">send them the terms link</a>.
		</ng-template>
	</div>
</div>

<dx-popup [(visible)]="showUsersPopup" [title]="usersPopupTitle" [width]="'auto'" [minWidth]="termsToolsEnabled ? 480 : 400" [maxWidth]="termsToolsEnabled ? 860 : 800" [height]="'auto'" [maxHeight]="termsToolsEnabled ? 560 : 500" [showCloseButton]="true" [hideOnOutsideClick]="true"
	(onHidden)="proceedPendingSwitch()"
	[elementAttr]="{ 'data-testid': 'facility-card-popup-users' }">
	<div *dxTemplate="let data of 'content'">
		<div *ngIf="pendingSwitch" class="alert alert-warning py-2 px-3 small mb-2"
			data-testid="facility-card-intercept-copy">
			This customer hasn't accepted the Terms &amp; Conditions yet. Please send a user the
			terms link (or add a user) before continuing — or click <b>Cancel</b> to go straight
			to the facility.
		</div>
		<div *ngIf="termsToolsEnabled && facility.require_terms_agreement" class="mb-2 small"
			data-testid="facility-card-terms-popup-copy">
			Select the user who should sign for this customer and click <b>Send Terms Link</b> —
			they will receive an email with a link to review and accept the Terms &amp; Conditions.
			<div class="text-muted mt-1">
				Right person not listed? Send their name and email address to
				<a href="mailto:customersupport@letybousa.com">customersupport@letybousa.com</a>
				and we will add them to the account.
			</div>
		</div>
		<dx-data-grid [dataSource]="facility.users" [showBorders]="true" [rowAlternationEnabled]="true" [columnAutoWidth]="true">
			<dxi-column dataField="name" caption="Name"></dxi-column>
			<dxi-column dataField="email" caption="Email"></dxi-column>
			<dxi-column dataField="phone" caption="Phone"></dxi-column>
			<dxi-column *ngIf="termsToolsEnabled" dataField="vett_status" caption="Status"></dxi-column>
			<dxi-column *ngIf="termsToolsEnabled && facility.require_terms_agreement" caption="" cellTemplate="actionsTpl" [width]="170"></dxi-column>
			<div *dxTemplate="let cell of 'actionsTpl'">
				<dx-button text="Send Terms Link" stylingMode="outlined" type="default" [disabled]="!cell.data.id || pending || cell.data.vett_status === 'Denied'"
					(onClick)="sendTermsLink(cell.data)"
					[elementAttr]="{ 'data-testid': 'facility-card-btn-send-terms' }"></dx-button>
			</div>
		</dx-data-grid>
		<div *ngIf="termsToolsEnabled && (!facility.users || facility.users.length === 0)" class="mt-2">
			<dx-button text="Add User" type="default" (onClick)="showAddUserForm = true"
				[elementAttr]="{ 'data-testid': 'facility-card-btn-add-user' }"></dx-button>
		</div>
		<div *ngIf="pendingSwitch" class="mt-2 text-right">
			<dx-button text="Cancel" stylingMode="outlined" type="normal"
				(onClick)="showUsersPopup = false"
				[elementAttr]="{ 'data-testid': 'facility-card-btn-skip-select' }"></dx-button>
		</div>
	</div>
</dx-popup>

<dx-popup *ngIf="termsToolsEnabled" [(visible)]="showAddUserForm" title="Add User" [width]="420" [height]="'auto'" [showCloseButton]="true"
	[elementAttr]="{ 'data-testid': 'facility-card-popup-add-user' }">
	<div *dxTemplate="let data of 'content'">
		<dx-text-box [(value)]="newUser.first_name" label="First name" class="mb-2" [elementAttr]="{ 'data-testid': 'facility-card-input-new-first' }"></dx-text-box>
		<dx-text-box [(value)]="newUser.last_name" label="Last name" class="mb-2" [elementAttr]="{ 'data-testid': 'facility-card-input-new-last' }"></dx-text-box>
		<dx-text-box [(value)]="newUser.email" label="Email" class="mb-2" [elementAttr]="{ 'data-testid': 'facility-card-input-new-email' }"></dx-text-box>
		<dx-text-box [(value)]="newUser.phone" label="Phone" class="mb-2" [elementAttr]="{ 'data-testid': 'facility-card-input-new-phone' }"></dx-text-box>
		<dx-button text="Create" type="default" [disabled]="pending" (onClick)="addUser()" [elementAttr]="{ 'data-testid': 'facility-card-btn-create-user' }"></dx-button>
	</div>
</dx-popup>
